import { useState } from 'react';
import { PageShell, SlidePanel } from '@/shared/components';
import { TeamsTable } from '../components/TeamsTable';
import { TeamPanel } from '../components/TeamPanel';
import type { Team } from '../types';

const PANEL_KEY = 'atek_teams_panel_width';

export function TeamsPage() {
  const [editingTeam, setEditingTeam] = useState<Team | null>(null);
  const [panelOpen, setPanelOpen] = useState(false);

  const openCreate = () => {
    setEditingTeam(null);
    setPanelOpen(true);
  };
  const openEdit = (team: Team) => {
    setEditingTeam(team);
    setPanelOpen(true);
  };
  const closePanel = () => {
    setPanelOpen(false);
    // keep editingTeam so close animation has the right title; reset on next open
  };

  return (
    <PageShell>
      <div className="flex min-h-[calc(100vh-240px)]">
        <div className="flex-1 min-w-0 overflow-auto">
          <TeamsTable onRowClick={openEdit} onCreate={openCreate} />
        </div>
        <SlidePanel open={panelOpen} storageKey={PANEL_KEY}>
          <TeamPanel
            key={editingTeam?.id ?? 'create'}
            team={editingTeam}
            onClose={closePanel}
          />
        </SlidePanel>
      </div>
    </PageShell>
  );
}
